/* Interfaces */
import { IFormInput } from "../interfaces/IFormInput";

const form: Record<string, IFormInput> = {
  name: {
    name: "* Imię",
    value: "",
    type: "text",
    errorMessage: "",
    valid: null,
    id: "name",
    validation: {
      condition: "longer-than-2",
      errorMessage: "Imię musi zawierać co najmniej 2 znaki",
    },
  },
  email: {
    name: "* E-Mail",
    value: "",
    type: "email",
    errorMessage: "",
    valid: null,
    id: "e-mail",
    validation: {
      condition: "email",
      errorMessage: "To nie jest poprawny adres email",
    },
  },
};

const checkbox: IFormInput = {
  value: false,
  type: "checkbox",
  errorMessage: "",
  valid: null,
  id: "agree-to-terms",
  validation: {
    condition: "required",
    errorMessage: "To pole jest obowiązkowe",
  },
};

const textarea: IFormInput = {
  name: "Dodatkowe uwagi",
  value: "",
  id: "additional-notes",
};

export { form, checkbox, textarea };
